import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { IDataSourceModalState } from './dataSourceModals.interface';
import { dataSourceModalInitialState } from './datasourceModals.constants';
import {
  IDataSourceTypesResponse,
  TDataSource,
} from 'Modules/Studio/DataSources/redux/initialState';
import { getDataSourceDefaultValues } from './helpers';

export const datasourceModalsReducer = {
  resetState: (state: IDataSourceModalState) => {
    state.isOpen = dataSourceModalInitialState.isOpen;
    state.isNew = dataSourceModalInitialState.isNew;
    state.selectedDataSource = dataSourceModalInitialState.selectedDataSource;
    state.view = dataSourceModalInitialState.view;
  },

  openDataSourceModalForNewDataSource: (state: IDataSourceModalState) => {
    state.isOpen = true;
    state.isNew = true;
    state.selectedDataSource = null;
    state.view = 'selectType';
  },

  openDataSourceModalForExistingDataSource: (
    state: IDataSourceModalState,
    action: PayloadAction<TDataSource>
  ) => {
    state.isOpen = true;
    state.isNew = false;
    state.selectedDataSource = action.payload;
    state.view = 'form';
  },

  updateSelectedDataSourceForModal: (
    state: IDataSourceModalState,
    action: PayloadAction<TDataSource>
  ) => {
    state.selectedDataSource = action.payload;
    state.isNew = false;
  },

  closeDataSourceModal: (state: IDataSourceModalState) => {
    state.isOpen = dataSourceModalInitialState.isOpen;
    state.isNew = dataSourceModalInitialState.isNew;
    state.selectedDataSource = dataSourceModalInitialState.selectedDataSource;
    state.view = dataSourceModalInitialState.view;
  },

  setSelectedDataSourceModalType: (
    state: IDataSourceModalState,
    action: PayloadAction<{
      dataSourceType: number;
      selectedDatasourceDefaults: IDataSourceTypesResponse;
    }>
  ) => {
    let defaultValues = getDataSourceDefaultValues(
      action.payload.dataSourceType,
      action.payload.selectedDatasourceDefaults
    );

    state.selectedDataSource = defaultValues;
    state.view = 'form';
  },

  goBackToSelectTypeViewInDataSourceModal: (state: IDataSourceModalState) => {
    state.view = 'selectType';
  },
};

const datasourceModalsReduxSlice = createSlice({
  name: 'datasourceModals',
  initialState: dataSourceModalInitialState,
  reducers: datasourceModalsReducer,
});

export const {
  resetState,
  openDataSourceModalForNewDataSource,
  openDataSourceModalForExistingDataSource,
  updateSelectedDataSourceForModal,
  closeDataSourceModal,
  setSelectedDataSourceModalType,
  goBackToSelectTypeViewInDataSourceModal,
} = datasourceModalsReduxSlice.actions;

export default datasourceModalsReduxSlice.reducer;
